<template>
  <div id="tradeLeadNew">
    <NavBar fixed title="编辑" style="background-color: #f7f7f7">
      <template #left><Icon @click="allReturn()" name="arrow-left" size="22" color="#666"/></template>
      <template #right><span @click="allSave()" style="color: rgba(212, 48, 48, 1)">发布</span></template>
    </NavBar>
    <div class="indiv" style="background-color: #f5f5f5;height: calc(100vh - 46px);margin-top: 46px;overflow: auto">
      <div class="indiv92">
<!--        <div class="ExploreBody">-->
<!--          <input v-model="postData.heading" type="text" class="allInput" placeholder="请输入标题" style="width: calc(100% - 10px)"/>-->
<!--        </div>-->
        <div class="ExploreBody">
          <textarea v-model="postData.content" style="font-size: 14px" placeholder="请输入内容..."></textarea>
        </div>
        <div class="fileDiv">
          <dl>
            <dt v-if="postData.messageType === 'image'" :key="index" v-for="(item, index) in myFileImgList">
              <img :src="item">
              <section>
                <Icon @click="delImg(index)" name="cross" size="18" color="#ffffff"/>
              </section>
            </dt>
            <dt v-if="postData.messageType === 'video'" style="width: 50%;height: auto">
              <label for="traFile">
                <video :poster="postData.videoThumbUrl || ''" width="100%" controls>
                  <!--                <source :src="postData.videoUrl" type="video/mp4">-->
                  <source :src="postData.videoUrl" type="video/mp4">
                </video>
              </label>
              <section>
                <Icon @click="postData.videoUrl = '';postData.messageType = ''" name="cross" size="18" color="#ffffff"/>
              </section>
            </dt>
            <dd>
<!--              <img src="../assets/addUp_01.png" width="100%">-->
              <div v-if="formType === 'video'">
<!--                <img src="../assets/addUp_01.png" width="100%">-->
                <input @change="uploadVideoFun($event)" type="file" class="traFile" id="traFile"  accept="video/mp4">
                <label v-if="!postData.videoUrl" for="traFile">
                  <img src="../assets/addUp_01.png" width="100%">
                </label>
              </div>
              <div v-if="formType === 'image'">
<!--                <img v-if="myFileImgList.length < 9" @click="chooseWXImg" src="../assets/addUp_01.png" width="100%">-->
                <input @change="uploadImageFun($event)" type="file" class="traFile" id="traFile2"  accept="image/*">
                <label v-if="!postData.videoUrl" for="traFile2">
                  <img src="../assets/addUp_01.png" width="100%">
                </label>
              </div>
<!--              <picUpload v-if="formType === 'image'" @onChange='imgChange' :maxSize="maxSize" placeholder="选择图片" :defaultImg="FrontofCertificate" ></picUpload>-->
<!--              <picUploadVideo  v-if="formType === 'video' && postData.videoUrl === ''" @onChange='videoChange' :maxSize="maxSize" placeholder="选择视频" :defaultImg="FrontofCertificate"></picUploadVideo>-->
            </dd>
          </dl>
        </div>
      </div>
<!--      <div class="scIDv">-->
<!--        <div class="cover"></div>-->
<!--        <div>-->
<!--          <div>-->
<!--            <picUpload @onChange='imgChange' :maxSize="maxSize" placeholder="选择图片" :defaultImg="FrontofCertificate"></picUpload>-->
<!--            <picUploadVideo @onChange='imgChange' :maxSize="maxSize" placeholder="选择视频" :defaultImg="FrontofCertificate"></picUploadVideo>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="textcenter magtop_6">-->
<!--        <button @click="allSave()" class="blueButton">发布</button>-->
<!--      </div>-->
    </div>
    <div v-if="loading" style="display: flex;left: 0;right: 0;bottom: 0;top: 0;position: fixed;align-items: center;justify-content: center">
      <div style="text-align: center;position: relative;top: -50px">
        <p><img src="../assets/loading3.gif" width="50%"/></p>
        <p>视频正在上传中，请耐心等待</p>
      </div>
    </div>
  </div>
</template>

<script>
import FrontofCertificate from '../assets/addUp_01.png'
import {Icon, NavBar} from 'vant'
var qiniu = require('qiniu-js')
let imgIndex = 0
export default {
  components: {
    Icon,
    NavBar
  },
  name: 'tradeLeadNew',
  data () {
    return {
      loading: false,
      formType: this.$route.query.formType,
      postData: {
        // heading: '',
        content: '',
        messageType: 'image',
        pictureJsons: '',
        videoUrl: ''
      },
      qiniuToken: '',
      domain: '',
      myFileImgList: [],
      maxSize: 9999,
      FrontofCertificate: FrontofCertificate
    }
  },
  created() {
    this.$axiox.post('/file/getUpToken', {}, 1).then(p => {
      this.qiniuToken = p.data.upToken
      this.domain = p.data.domain
    })
  },
  mounted() {
  },
  methods: {
    async chooseWXImg () {
      let that = this
      let res = await this.$axiox.asyncPost(
          '/pay/getSdkConfig?url=' +
          encodeURIComponent(window.location.href.split('#')[0])
      )
      if (this.myFileImgList.length > 9) {
        return
      }
      this.$wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识,管理公众号页面可以获取
        timestamp: res.timestamp, // 必填，生成签名的时间戳,后台返回
        nonceStr: res.nonceStr, // 必填，生成签名的随机串,后台返回
        signature: res.signature, // 必填，签名,后台返回
        jsApiList: ['openLocation', 'getLocation', 'chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表,写入自己用到的接口名称
      })
      this.$wx.ready(p => {
        this.$wx.chooseImage({
          count: 9 - this.myFileImgList.length,
          sizeType: ['original', 'compressed'],
          sourceType: ['album', 'camera'],
          success: function (res) {
            console.log(res.localIds)
            if (res.localIds && res.localIds.length > 0) {
              imgIndex = 0
              that.getLocalData(res.localIds)

            }
          }
        })
        // this.$wx.chooseVideo({
        //   maxDuration: 30,
        //   camera: 'back',
        //   success(res) {
        //     console.log(res.tempFilePath)
        //   }
        // })
      })
      // document.getElementById(this.inputId).click()
    },
    getLocalData (localIds) {
      let that = this
      that.$wx.getLocalImgData({
        localId: localIds[imgIndex].toString(), // 图片的localID
        success: function (getLocal) {
          var localData = getLocal.localData // localData是图片的base64数据，可以用img标签显示
          console.log(localData)
          let file = that.dataURLtoFile(localData)
          // var config = {
          //   useCdnDomain: true,
          //   region: null
          // };
          // let putExtra = {
          //   fname: "",          // 文件原文件名
          //   params: {},         // 放置自定义变量： 'x:name': 'sex'
          //   mimeType: null      // 限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
          // };
          // var observable = qiniu.upload(file, 'fileUpload', this.qiniuToken, putExtra, config)
          // var subscription = observable.subscribe({   // 上传开始
          //   next: (result) => {
          //     console.log(result)
          //   },
          //   error: (errResult) => {
          //     // 上传错误后失败报错
          //     console.log(errResult)
          //     // alert(errResult)
          //     // alert(JSON.stringify(errResult))
          //     that.loading = false
          //   },
          //   complete: (result) => {
          //     // alert(result)
          //     // alert(JSON.stringify(result))
          //     console.log(result)
          //     if (imgIndex < localIds.length - 1) {
          //       imgIndex++
          //       that.getLocalData(localIds)
          //     }
          //     this.myFileImgList.push('http://' + that.domain + '/' + result.key)
          //   }
          // })
          that.newUploadFile(file)
          if (imgIndex < localIds.length - 1) {
            imgIndex++
            that.getLocalData(localIds)
          }
        },
        fail: function (res) {
          console.log('error' + res)
        }
      })
    },
    async newUploadFile (file) {
      if (this.myFileImgList.length < 9) {
        let fileId = await this.$commonJs.uploadIdCardFile(file, 1)
        this.myFileImgList.push(fileId.imageUrl)
      }
    },
    dataURLtoFile (dataurl) {
      let arr = dataurl.split(',')
      let bstr = atob(arr[1] || dataurl)
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], '1.jpg', {type: 'image/jpg'})
    },
    deleteImg (index) {
      this.imageDataList.splice(index, 1)
      this.countText = `${this.imageDataList.length}张图片`
    },
    allReturn () {
      this.$router.go(-1)
    },
    videoChange (files) {
      console.log(files)
      if (files) {
        this.myFileImgList.push(files)
        this.postData.messageType = 'video'
        // this.postData.imgList[0].frontImgUrl = files
        // if (this.$commonJs.imgUpLoadFileList.indexOf(fileType.toLowerCase()) > 0) {
        //   this.myFileImgList.push(files)
        //   this.postData.messageType = 'image'
        // } else {
        //   this.postData.videoUrl = files
        //   this.postData.messageType = 'video'
        // }
      }
    },
    imgChange (files) {
      console.log(files)
      if (files) {
        if (this.myFileImgList.length < 9) {
          for (let i = 0; i < files.length; i++) {
            this.myFileImgList.push(files[i])
          }
        }
        this.postData.messageType = 'image'
        // this.postData.imgList[0].frontImgUrl = files
        // if (this.$commonJs.imgUpLoadFileList.indexOf(fileType.toLowerCase()) > 0) {
        //   this.myFileImgList.push(files)
        //   this.postData.messageType = 'image'
        // } else {
        //   this.postData.videoUrl = files
        //   this.postData.messageType = 'video'
        // }
      }
    },
    async uploadcontOperFile (e) {
      let file = e.target.files[0]
      let fileType = file.name.split('.')[file.name.split('.').length - 1]
      if (this.$commonJs.imgUpLoadFileList.indexOf(fileType.toLowerCase()) < 0) {
        this.$commonJs.showTips('请上传图片')
        e.target.value = ''
        return
      }
      if (e.target.files) {
        let data = {
          fileName: e.target.files[0].name,
          id: await this.$commonJs.uploadIdCardFile(e.target.files[0], 1)
        }
        this.myFileImgList.push(data.id.imageUrl)
      }
      e.target.value = ''
    },
    async uploadImageFun (e) {
      let that = this
      if (e.target.files) {
        let fileSize = e.target.files[0]
        if (fileSize > 1024 * 1024 * 10) {
          this.$commonJs.showTips('图片不大于10M')
          e.target.value = ''
          return
        }
        var config = {
          useCdnDomain: true,
          region: null
        };
        let putExtra = {
          fname: "",          // 文件原文件名
          params: {},         // 放置自定义变量： 'x:name': 'sex'
          mimeType: null      // 限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        };
        let name = e.target.files[0].name
        var observable = qiniu.upload(e.target.files[0], new Date().getTime(), this.qiniuToken, putExtra, config)
        console.log(observable)
        var subscription = observable.subscribe({   // 上传开始
          next: (result) => {
            console.log(result)
          },
          error: (errResult) => {
            // 上传错误后失败报错
            console.log(errResult)
            // alert(errResult)
            // alert(JSON.stringify(errResult))
            that.loading = false
          },
          complete: (result) => {
            // alert(result)
            // alert(JSON.stringify(result))
            if (this.myFileImgList.length < 9) {
              this.myFileImgList.push('http://' + that.domain + '/' + result.key)
            }
          }
        })
      }
      e.target.value = ''
    },
    async uploadVideoFun (e) {
      let that = this
      if (e.target.files) {
        let fileSize = e.target.files[0]
        if (fileSize > 1024 * 1024 * 100) {
          this.$commonJs.showTips('视频不大于100M')
          e.target.value = ''
          return
        }
        var config = {
          useCdnDomain: true,
          region: null
        };
        let putExtra = {
          fname: "",          // 文件原文件名
          params: {},         // 放置自定义变量： 'x:name': 'sex'
          mimeType: ['video/mp4']      // 限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        };
        let name = e.target.files[0].name
        var observable = qiniu.upload(e.target.files[0], new Date().getTime(), this.qiniuToken, putExtra, config)
        console.log(observable)
        this.loading = true
        var subscription = observable.subscribe({   // 上传开始
          next: (result) => {
            console.log(result)
          },
          error: (errResult) => {
            // 上传错误后失败报错
            console.log(errResult)
            // alert(errResult)
            // alert(JSON.stringify(errResult))
            that.loading = false
          },
          complete: (result) => {
            // alert(result)
            // alert(JSON.stringify(result))
            console.log(result)
            // 接收成功后返回的信息
            let data = {
              fileName: name,
              id: {
                imageUrl: 'http://' + that.domain + '/' + result.key,
                videoThumbUrl: 'http://' + that.domain + '/' + result.key + '?vframe/jpg/offset/1|imageView2/0/w/720'
              }
            }
            this.postData.videoUrl = data.id.imageUrl
            this.postData.videoThumbUrl = data.id.videoThumbUrl
            this.postData.messageType = 'video'
            this.loading = false
          }
        })
      }
      e.target.value = ''
    },
    delImg (index) {
      this.myFileImgList.splice(index, 1)
    },
    allSave () {
      if (this.postData.content === '') {
        this.$commonJs.showTips('请输入内容')
        return
      }
      if (this.postData.messageType === 'image') {
        this.postData.videoUrl = ''
        this.postData.pictureJsons = this.myFileImgList.join(',') || ''
      }
      if (this.postData.messageType === 'video') {
        this.postData.pictureJsons = ''
      }
      let data = JSON.parse(JSON.stringify(this.postData))
      this.$axiox.post('/explore/Msg', data).then(() => {
        this.$commonJs.showTips('发布成功')
        this.$router.go(-1)
      })
    }
  }
}
</script>

<style scoped>
.indiv92 {
  background-color: white;
}
.ExploreBody {
  padding: 10px 0;
}
.ExploreBody textarea {
  resize: none;
  padding: 10px;
  width: calc(100% - 20px);
  height: 40vh;
  border: none;
}
.fileDiv dl {
  white-space: normal;
}
.fileDiv dl dt, .fileDiv dl dd {
  display: inline-block;
  vertical-align: middle;
  width: 84px;
  height: 84px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.fileDiv dl dt {
  overflow: hidden;
  position: relative;
}
.fileDiv dl dt > section {
  background-color: red;
  position: absolute;
  top: 0;
  right: 0;
}
.fileDiv dl dt > img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.traFile {
  display: none;
}
.traFile + label {
  display: flex;
  vertical-align: middle;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  color: #b1b1b1;
  border-radius: 5px;
  font-size: 44px;
}
.scIDv {
  /*position: fixed;*/
  /*top: 0;*/
  /*left: 0;*/
  /*right: 0;*/
  /*bottom: 0;*/
}
.scIDv > div:last-child {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scIDv > div:last-child div {
  width: 70%;
  background-color: white;
  text-align: center;
}
</style>
